import React, {Component} from 'react'
import {schools} from '../schools'
import withTheme from 'material-ui/styles/withTheme'
import withStyles from 'material-ui/styles/withStyles';
import TextField from 'material-ui/TextField';
import Paper from 'material-ui/Paper';
import Downshift from 'downshift';
import {styles} from '../styles'
import Grid from 'material-ui/Grid'
import Typography from 'material-ui/Typography/Typography'
import { compose } from 'redux';
import { firebaseConnect } from 'react-redux-firebase';
import Button from 'material-ui/Button'
import {connect} from 'react-redux'
import List, { ListItem, ListItemText } from 'material-ui/List';
import Menu, { MenuItem } from 'material-ui/Menu';

import Input, { InputLabel } from 'material-ui/Input'
import { FormControl } from 'material-ui/Form'
import {profileAdd} from './action'
import {push} from 'react-router-redux'
const types = [
  'นักเรียนมัธยม',
  'นักศึกษา',
  'ครู/อาจารย์',
  'ผู้ปกครอง',
  'อื่นๆ'
]

const classLevels = ['ม. 6','ม. 5','ม. 4','ม. 3','ม. 2','ม. 1']

function renderInput(inputProps) {
    const { InputProps, classes, ref, ...other } = inputProps;
  
    return (
      <TextField
        style={{width: '100%'}}
        {...other}
        inputRef={ref}
        InputProps={{
          classes: {
            input: classes.input,
          },
          ...InputProps,
        }}
        
      />
    );
}

function renderSchool(params) {
    const { school, index, itemProps, highlightedIndex, selectedItem } = params;
    const isHighlighted = highlightedIndex === index;
    const isSelected = selectedItem === school;
  
    return (
      <MenuItem
        {...itemProps}
        key={school}
        selected={isHighlighted}
        component="div"
        style={{
          fontWeight: isSelected ? 500 : 400,
          width: '95%'
        }}
      >
        {school}
      </MenuItem>
    );
}

function getSchools(inputValue) {
    let count = 0;
  
    return schools.filter(school => {
      const keep =
        (!inputValue || school.toLowerCase().includes(inputValue.toLowerCase())) &&
        count < 10;
  
      if (keep) {
        count += 1;
      }
  
      return keep;
    });
  }
  

class ProfileContainer extends Component {
  state={
    name: "",
    level: "",
    school: "",
    type: "",
    anchorEl: null,
    anchorElClass: null,
    selectedIndex: -1,
    selectedClassIndex:  -1,
  }
  handleClickListItem = event => {
    this.setState({ anchorEl: event.currentTarget });
  }
  handleClickClassListItem = event => {
    this.setState({ anchorElClass: event.currentTarget });
  }

  handleMenuItemClick = (event, index) => {
    this.setState({ selectedIndex: index, anchorEl: null , type: types[index]});
  }
  handleClassMenuItemClick = (event, index) => {
    this.setState({ selectedClassIndex: index, anchorElClass: null, level: classLevels[index] });
  }

  handleChange = prop => event => {
    this.setState({ [prop]: event.target.value})
  }
  componentWillReceiveProps() {
    this.setState({email: this.props.email})
  }
  render(){

    const classes = this.props.classes
    return (
        <div>
          {this.props.profile.profileCompleted?this.props.dispatch(push('/'))
          :
          <Grid container style={{marginTop: "0px"}} className={this.props.classes.centerGrid} spacing={0}>
            <Grid item xs={12} md={4} className={this.props.classes.itemGrid}>
              <Typography type="title" color="default" >
                กรอกรายละเอียดเพื่อเริ่มทำแบบทดสอบ
              </Typography>
              <FormControl fullWidth style={{width: '95%'}} className={this.props.classes.formControl}>
                <InputLabel htmlFor="email">ชื่อ-นามสกุล (ภาษาไทย)</InputLabel>
                <Input
                    className={this.props.classes.fullTextInput}
                    //type="email"
                    onChange={this.handleChange('name')}
                    value={this.state.name}
                />
              </FormControl>
              <FormControl fullWidth style={{width: '95%'}} className={this.props.classes.formControl}>
                <List component="nav">
                  <ListItem
                    button
                    aria-haspopup="true"
                    aria-controls="lock-menu"
                    aria-label="When device is locked"
                    onClick={this.handleClickListItem}
                  >
                    <ListItemText
                      primary="ประเภทผู้ใช้"
                      secondary={types[this.state.selectedIndex]}
                    />
                  </ListItem>
                </List>
                <Menu
                  id="lock-menu"
                  anchorEl={this.state.anchorEl}
                  open={Boolean(this.state.anchorEl)}
                  onClose={this.handleClose}
                >
                  {types.map((option, index) => (
                    <MenuItem
                      key={option}
                      selected={index === this.state.selectedIndex}
                      onClick={event => this.handleMenuItemClick(event, index)}
                    >
                      {option}
                    </MenuItem>
                  ))}
                </Menu>
              </FormControl>
              {this.state.selectedIndex !== 0?null
              :
              <FormControl fullWidth style={{width: '95%'}} className={this.props.classes.formControl}>
                <List component="nav">
                  <ListItem
                    button
                    aria-haspopup="true"
                    aria-controls="lock-menu"
                    aria-label="ระดับชั้น"
                    onClick={this.handleClickClassListItem}
                  >
                    <ListItemText
                      primary="ระดับชั้น"
                      secondary={classLevels[this.state.selectedClassIndex]}
                    />
                  </ListItem>
                </List>
                <Menu
                  id="lock-menu"
                  anchorEl={this.state.anchorElClass}
                  open={Boolean(this.state.anchorElClass)}
                  onClose={this.handleClose}
                >
                  {classLevels.map((option, index) => (
                    <MenuItem
                      key={option}
                      selected={index === this.state.selectedClassIndex}
                      onClick={event => this.handleClassMenuItemClick(event, index)}
                    >
                      {option}
                    </MenuItem>
                  ))}
                </Menu>
              </FormControl>
              }
              {this.state.selectedIndex !== 0?null
              :
                <FormControl fullWidth style={{width: '95%'}} className={this.props.classes.formControl}>
                
                  <Downshift 
                    style={{width: '95%'}}
                    onChange={selection=>this.setState({school: selection})}>
                    {({ getInputProps, getItemProps, isOpen, inputValue, selectedItem, highlightedIndex }) => (
                      <div >
                        {renderInput({
                          fullWidth: true,
                          classes,
                          InputProps: getInputProps({
                            placeholder: 'ค้นหาโรงเรียน',
                            id: 'integration-downshift',
                          }),
                        })}
                        {isOpen ? (
                          <Paper square style={{width: '95%'}}>
                            {getSchools(inputValue).map((school, index) =>
                              renderSchool({
                                school,
                                index,
                                itemProps: getItemProps({ item: school }),
                                highlightedIndex,
                                selectedItem,
                              }),
                            )}
                          </Paper>
                        ) : null}
                      </div>
                    )}
                  </Downshift>
                </FormControl>  
              }
              
              <FormControl  fullWidth className={this.props.classes.formControl}>
                <Button  
                    disabled={
                      !this.state.name || !this.state.type //|| !this.state.school
                    }
                    variant="raised"
                    size="large"
                    color="secondary"
                    className={this.props.classes.fullButton}
                    onClick={()=>this.props.dispatch(profileAdd(
                      this.state.name,
                      this.state.level,
                      this.state.school,
                      this.state.type
                    ))}
                  >
                    
                    <span style={{fontSize: '120%'}}>
                        เริ่มทำแบบทดสอบ
                    </span>
                </Button>
              </FormControl>
            </Grid>
          </Grid>
          }
        </div>
    )
  }
}
export default compose(
  firebaseConnect(),
  withTheme(),
  withStyles(styles),
  connect( ({firebase: {profile}})=>({profile})))(ProfileContainer)


// WEBPACK FOOTER //
// ./src/profile/ProfileContainer.js